import React, { useEffect, useState } from 'react';
import { apiClient } from '../App';
import MonthlySummaryModal from './MonthlySummaryModal';

// Pops up last month's summary once, the first time a member opens the app after it's ready
export const MonthlySummaryPrompt = () => {
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    apiClient.get('/summaries/check-new')
      .then(async (res) => {
        if (!res.data.has_new_summary) return;
        const full = await apiClient.get(`/summaries/${res.data.year}/${res.data.month}`);
        setSummary(full.data);
      })
      .catch(() => {});
  }, []);

  const markViewed = async (year, month) => {
    try {
      await apiClient.post(`/summaries/${year}/${month}/mark-viewed`);
    } finally {
      setSummary(null);
    }
  };

  return (
    <MonthlySummaryModal
      isOpen={!!summary}
      onClose={() => setSummary(null)}
      summary={summary}
      onMarkViewed={markViewed}
    />
  );
};
